export default __webpack_public_path__ + "static/media/subtract-2.d5ebab72.png";